import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Button,
  Grid,
  Popover,
  Typography,
  TextField,
  List,
  Divider,
  Paper,
  FormControl,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  InputAdornment,
  Dialog,
  DialogTitle,
  DialogContent,
  Select,
  Chip,
  MenuItem as MuiMenuItem,
} from "@mui/material";

import Menu from "@mui/material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import StatusCard from "../../BOOKLET_MODUL/Components/Statuscard/StatusCard";
import CommonTable2, {
  type Column,
} from "../../BOOKLET_MODUL/Components/CommonTable/CommonTable2";
import DashboardDonutCard from "../../BOOKLET_MODUL/Components/ProgressChartCard/ProgressChartCard";
import { useAppDispatch, useAppSelector } from "../../../Redux/Store/Hooks";
import { TutorAdminDashboardRead } from "../../../Redux/Slices/Booklet/Admin/DashboardData/Dashboarddata";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import SearchIcon from "@mui/icons-material/Search";
import { centreMasterRead } from "../../../Redux/Slices/Booklet/Admin/CentreMaster/CentreMatserRead";
import { ICenter } from "../Master/Center/ICenter";
import { Tutoradmin_Calendar } from "../../../Redux/Slices/Booklet/Admin/CalenderView/CalenderView";
import CalendarView from "../../BOOKLET_MODUL/Components/Calendar/CalenderView";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFnsV3";
import AlertBox from "../../BOOKLET_MODUL/Components/AlertBox/AlertBox";

const AdminDashboard: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedCenter, setSelectedCenter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [openPopup, setOpenPopup] = React.useState(false);
  const [selectedClasses, setSelectedClasses] = React.useState<any[]>([]);
  const [selectedMonth, setSelectedMonth] = useState<number | null>(null);
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [openAlert, setOpenAlert] = useState(false);

  const [filters, setFilters] = React.useState<any>({});
  const [tempFilters, setTempFilters] = React.useState<any>({});
  const [filteranchorEl, setFilterAnchorEl] =
    React.useState<null | HTMLElement>(null);
  const dropdownOpen = Boolean(filteranchorEl);
  const [openFilterPopup, setOpenFilterPopup] = React.useState(false);

  const formatDateForFilter = (date: Date | null) => {
    if (!date) return "";
    return date
      .toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "2-digit",
        year: "2-digit",
      })
      .replace(/\//g, "-");
  };

  const { data: DashboardData, isLoading } = useAppSelector(
    (state) => state.TutorAdminDashboarRead
  );

  const { data: listCentersData } = useAppSelector(
    (state) => state.CentreMasterReadSlice
  );

  const { data: CalendarData, isLoading: dateLoading } = useAppSelector(
    (state) => state.TutorAdminDashboardCalender
  );

  console.log(selectedYear, selectedMonth, "selectedMonth");
  const SummaryData = DashboardData?.data;
  const centers = useMemo<ICenter[]>(() => {
    if (!listCentersData) {
      return [];
    }

    if ("data" in listCentersData && Array.isArray(listCentersData.data)) {
      return listCentersData.data;
    }

    return [];
  }, [listCentersData]);

  const filteredCenters = useMemo(() => {
    if (!searchQuery.trim()) return centers;
    return centers.filter(
      (center) =>
        center?.center_name
          ?.toLowerCase()
          .includes(searchQuery.toLowerCase()) ?? false
    );
  }, [centers, searchQuery]);

  const selectedCenterName =
    centers.find((c: any) => c.id.toString() === selectedCenter)?.center_name ||
    "";

  useEffect(() => {
    dispatch(TutorAdminDashboardRead(0));
    dispatch(Tutoradmin_Calendar({}));
    dispatch(centreMasterRead());
  }, [dispatch]);

  useEffect(() => {
    if (!(selectedYear && selectedMonth)) return;

    const payload: any = {
      month: selectedMonth,
      year: selectedYear,
    };

    if (selectedCenter) payload.center_id = selectedCenter;

    dispatch(Tutoradmin_Calendar(payload));
  }, [selectedCenter, selectedMonth, selectedYear]);
  console.log(CalendarData, "CalendarData");

  const formatDate = (dateString: string) => {
    if (!dateString) return "-";
    try {
      const dateParts = dateString.split("T")[0].split("-");
      if (dateParts.length !== 3) return "-";
      const [year, month, day] = dateParts;
      return `${day}-${month}-${year}`;
    } catch (error) {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return "-";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}-${month}-${year}`;
    }
  };

const formattedPendingRequests = useMemo(() => {
  return (SummaryData?.pending_booklet_requests || []).map((request: any) => {
    const firstSubject = request.subjects?.[0] || {};
    const subjectName = firstSubject?.name || "-";
    const yearGroup = firstSubject?.yeargroup_region?.yeargroup || "-";
    const tutorName = request?.tutor_data?.name || "-";
    const centerName = request?.center_data?.center_name || "-";
    const class_Details = request.class_details || null;
    const class_Details_day = class_Details?.day ||"-";
    const createdDate = new Date(request.created_at);

    return {
      ...request,
      tutor_name: tutorName,
      center_name: centerName,
      yeargroup: yearGroup,
      subject_name: subjectName,
      formatted_date: createdDate.toLocaleDateString("en-GB"), // dd/mm/yyyy
      class_details_day: class_Details_day,
      class_details: class_Details,
    };
  });
}, [SummaryData]);


  const formattedUpcomingClasses = useMemo(() => {
    return (SummaryData?.upcoming_class_schedule || []).map(
      (classItem: any) => {
        const centerName = classItem?.center?.center_name || "-";
        const yearLevel = classItem?.year_level || "-";
        const tutorName = classItem?.tutor_name || "-";
        const Print_request = classItem?.print_request || "-";

        return {
          ...classItem,
          tutor_name: tutorName,
          center_name: centerName,
          year_level: yearLevel,
          print_request: Print_request,
          formatted_date: formatDate(classItem.date),
        };
      }
    );
  }, [SummaryData]);

  const upcomingClasses = SummaryData?.upcoming_class_schedule;
  console.log(upcomingClasses,"upcomingClasses")

  useEffect(() => {
    const alertClosed = sessionStorage.getItem("printerAlertClosed");
    if (alertClosed === "true") {
      setOpenAlert(false);
      return;
    }

    if (!upcomingClasses || upcomingClasses.length === 0) {
      setOpenAlert(false);
      return;
    }

    const now = new Date();

    const tomorrow = new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1)
    );
    const tomorrowYear = tomorrow.getUTCFullYear();
    const tomorrowMonth = tomorrow.getUTCMonth();
    const tomorrowDayOfMonth = tomorrow.getUTCDate();

    const hasPendingPrint = upcomingClasses.some((cls: any) => {
      if (!cls.date) return false;
      if (cls.print_request !== "not_yet_requested") return false;

      const classDay = new Date(cls.date);
      const classYear = classDay.getUTCFullYear();
      const classMonth = classDay.getUTCMonth();
      const classDayOfMonth = classDay.getUTCDate();

      const isTomorrowMatch =
        classYear === tomorrowYear &&
        classMonth === tomorrowMonth &&
        classDayOfMonth === tomorrowDayOfMonth;

      console.log(
        `Class date: ${cls.date}, Status: ${
          cls.print_request
        }, Normalized UTC parts: ${classYear}-${
          classMonth + 1
        }-${classDayOfMonth}, Tomorrow UTC parts: ${tomorrowYear}-${
          tomorrowMonth + 1
        }-${tomorrowDayOfMonth}, Match: ${isTomorrowMatch}`
      );

      return isTomorrowMatch;
    });
    console.log(hasPendingPrint, "hasPendingPrint");
    setOpenAlert(hasPendingPrint);
  }, [upcomingClasses]);

  const statusColorMap = {
    not_yet_started: "#FF7A1A",
    requested: "#af50bf",
    in_progress: "#FFB800",
    completed: "#23A346",
    failed: "#E53935",
  };

  const statusOptions = [
    { label: "Printing Completed", value: "printed" },
    { label: "Requested", value: "requested" },
    { label: "In Progress", value: "approved" },
    { label: "Rejected / Failed", value: "rejected" },
    { label: "Not Started", value: "not_yet_requested" },
  ];

  const columnFilters: any = {
    date: {
      type: "select",
      label: "Date",
      options: () => {
        const dates = new Set(
          formattedUpcomingClasses.map((c: any) => c.date).filter(Boolean)
        );
        return ["All", ...Array.from(dates)].map((opt) => ({
          value: opt === "All" ? "" : opt,
          label: opt,
        }));
      },
    },
    center_name: {
      type: "select",
      label: "Center",
      options: () => {
        const centerOpts = Array.from(
          new Set(
            formattedUpcomingClasses
              .map((c: any) => c.center_name)
              .filter(Boolean)
          )
        );
        return ["All", ...centerOpts].map((opt) => ({
          value: opt === "All" ? "" : opt,
          label: opt,
        }));
      },
    },
    tutor_name: {
      type: "select",
      label: "Tutor Name",
      options: () => {
        const tutorOpts = new Set(
          formattedUpcomingClasses.map((c: any) => c.tutor_name).filter(Boolean)
        );
        return ["All", ...Array.from(tutorOpts)].map((opt) => ({
          value: opt === "All" ? "" : opt,
          label: opt,
        }));
      },
    },
    year_level: {
      type: "select",
      label: "Year Level",
      options: () => {
        const levelOpts = new Set(
          formattedUpcomingClasses.map((c: any) => c.year_level).filter(Boolean)
        );
        return ["All", ...Array.from(levelOpts)].map((opt) => ({
          value: opt === "All" ? "" : opt,
          label: opt,
        }));
      },
    },
     subject_name: {
      type: "select",
      label: "Subject",
      options: () => {
        const subjectOpts = new Set(
          formattedUpcomingClasses
            .map((c: any) => c.subject_name)
            .filter(Boolean)
        );
        return ["All", ...Array.from(subjectOpts)].map((opt) => ({
          value: opt === "All" ? "" : opt,
          label: opt,
        }));
      },
    },
    print_request: {
      type: "select",
      label: "Status",
      options: [{ value: "", label: "All" }, ...statusOptions],
    },
  };

  const getOptions = useMemo(
    () =>
      (key: string) => {
        const config = columnFilters[key];
        if (!config) return [];
        return typeof config.options === "function"
          ? config.options()
          : config.options;
      },
    [formattedUpcomingClasses]
  );

  const filteredUpcomingClasses = useMemo(() => {
    return formattedUpcomingClasses.filter((row: any) => {
      return Object.keys(filters).every((key) => {
        const filterValue = filters[key];
        if (!filterValue || (Array.isArray(filterValue) && filterValue.length === 0)) return true;

        const rowValue = String(row[key] || "");
        const filterValues = Array.isArray(filterValue)
          ? filterValue
          : [filterValue];

        return filterValues.some((fv: string) => rowValue === fv);
      });
    });
  }, [formattedUpcomingClasses, filters]);

  const scheduledColumns: Column[] = useMemo(
    () => [
      { field: "date", headerName: "Date" },
      { field: "center_name", headerName: "Center", sortable: true },
      { field: "tutor_name", headerName: "Tutor Name" },
      { field: "year_level", headerName: "Year Level" },
      { field: "subject_name", headerName: "Subject" },
      {
        field: "print_request",
        headerName: "Status",
        renderCell: (params: any) => {
          const status = params.value;
          const color =
            statusColorMap[status as keyof typeof statusColorMap] || "#gray";
          return (
            <Chip
              label={status || "-"}
              size="small"
              sx={{
                backgroundColor: color,
                color: "white",
                fontSize: "12px",
              }}
            />
          );
        },
      },
    ],
    []
  );

  const pendingColumns: Column[] = useMemo(
    () => [
      { field: "tutor_name", headerName: "Tutor Name" },
      { field: "center_name", headerName: "Center Name" },
      { field: "yeargroup", headerName: "Year Group" },
     {
  field: "class_details",
  headerName: "Class Details",
  align: "center",
  render: (row: any) => (
    <div
      style={{
        display: "inline-block",
        textAlign: "left",
      }}
    >
      {/* Subject always */}
      <div style={{ fontWeight: 500 }}>
        {row.subject_name || "-"}
      </div>

      {/* Day OR Custom Request */}
      {row.class_details !== null ? (
        <div style={{ fontSize: "13px", color: "#1976d2" }}>
          {row.class_details_day}
        </div>
      ) : (
        <div
          style={{
            marginTop: "4px",
            display: "inline-block",
            textAlign: "left",
            padding: "2px 8px",
            fontSize: "11px",
            borderRadius: "12px",
            backgroundColor: "#af50bf",
            color: "#ffffff",
            fontWeight: 500,
          }}
        >
          Custom Request
        </div>
      )}
    </div>
  ),
},
      {
        field: "formatted_date",
        headerName: "Date",
      },

      { field: "action", headerName: "Action" },
    ],
    []
  );

  const printingData = useMemo(() => {
    const summary = SummaryData?.printing_status_summary || {};
    return [
      {
        name: "Not Yet Started",
        value: summary.not_yet_started || 0,
        color: statusColorMap.not_yet_started,
      },
      {
        name: "Requested",
        value: summary.requested || 0, // Add if API provides; else 0
        color: statusColorMap.requested,
      },
      {
        name: "In Progress",
        value: summary.in_progress || 0,
        color: statusColorMap.in_progress,
      },
      {
        name: "Completed",
        value: summary.completed || 0,
        color: statusColorMap.completed,
      },
      {
        name: "Failed",
        value: summary.failed || 0,
        color: statusColorMap.failed,
      },
    ];
  }, [SummaryData]);

  const subjectData =
    SummaryData?.subject_wise_request_count?.map((s: any) => ({
      name: s.subject_name,
      topic: `${s.yeargroup_region.yeargroup} (${s.yeargroup_region.region})`,
      yearLevel: s.yeargroup_region.yeargroup,
      value: s.request_count,
      color: "#8B5CF6",
    })) || [];

  const calendarEvents: any = useMemo(() => {
    const data = CalendarData?.data;

    if (!Array.isArray(data)) return [];

    const statusMap = new Map<string, string>();
    const events: any[] = [];

    data?.forEach((item: any) => {
      const { requests = [], mapped_classes = [] } = item ?? {};

      requests?.forEach((req: any) => {
        const status = req?.printing_status || "not_yet_started";

        req?.carts?.forEach((cart: any) => {
          const csmId = cart?.assigned_class_selection;
          if (csmId) statusMap.set(csmId, status);
        });
      });

      // Add mapped classes to events
      mapped_classes?.forEach((cls: any) => {
        events.push({
          date: (cls?.date || "").split("T")[0],
          type: "class",
          data: {
            ...cls,
            printing_status: statusMap.get(cls?.csm_id) || "not_yet_started",
          },
        });
      });
    });

    return events;
  }, [CalendarData]);

  const handleFilterClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleSelectCenter = (centerId: string) => {
    setSelectedCenter(centerId);
  };

  console.log(selectedCenter, "selectedCenter");

  const handleSearch = () => {
    dispatch(TutorAdminDashboardRead({ Center_id: selectedCenter }));
    dispatch(Tutoradmin_Calendar({ center_id: selectedCenter }));
    handleClose();
    // Add your search logic here
  };

  const handleCancel = () => {
    setSelectedCenter("");
    setSearchQuery("");
    handleClose();
  };

  const dialogcolumns: Column[] = [
    { field: "center_name", headerName: "Center", sortable: true },
    { field: "tutor_name", headerName: "Tutor Name" },
    { field: "year_level", headerName: "Year Level" },
    { field: "subject_name", headerName: "Subject" },
    { field: "print_request", headerName: "Status" },
  ];

  const handleDayClick = (dayEvents: any[]) => {
    setSelectedClasses(dayEvents);
    setOpenPopup(true);
  };

  const formattedClasses = useMemo(() => {
    return (selectedClasses || []).map((classItem: any) => {
      const data = classItem?.data || {};

      return {
        id: data?.csm_id || Math.random(),

        // For API navigation
        center_id: data?.center?.center_id || data?.center_id || "-",
        center_name: data?.center?.center_name || data?.center_name || "-",

        tutor_id: data?.tutor?.id || data?.tutor_id || "-",
        tutor_name: data?.tutor?.name || data?.tutor_name || "-",

        yeargroup_id: data?.yeargroup?.id || data?.yeargroup_id || "-",
        year_level: data?.yeargroup?.year_group || "-",

        subject_id: data?.subject?.id || data?.subject_id || "-",
        subject_name: data?.subject?.name || "-",

        date: data?.date || "-",
        formatted_date: formatDate(data?.date),

        print_request: data?.print_request || "-",
        printing_status: data?.printing_status || "-",
        request_id: data?.request_id || "-",
      };
    });
  }, [selectedClasses]);
  console.log(selectedClasses, "selectedClasses");
  console.log(formattedClasses, "formattedClasses");

  const legendItems = [
    { label: "Not Requested", color: statusColorMap.not_yet_started },
    { label: "Requested", color: statusColorMap.requested },
    { label: "Approved", color: statusColorMap.in_progress },
    { label: "Print Completed", color: statusColorMap.completed },
    { label: "Rejected / Print Failed", color: statusColorMap.failed },
  ];

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <Box sx={{ p: 4, backgroundColor: "#F9FAFB", minHeight: "100vh" }}>
        {/* Header */}
        <Box
          sx={{
            mb: 3,
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Grid>
            <Typography variant="h5" fontWeight={700} color="text.primary">
              Admin - Dashboard
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Overall Center Dashboard
            </Typography>
          </Grid>
          <Grid
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <IconButton
              sx={{
                height: 37,
                width: 37,
                backgroundColor: "#009DDF",
                color: "#ffffff",
                cursor: "pointer",
                padding: "2px",
                borderRadius: "8px",
              }}
              onClick={handleFilterClick}
            >
              <FilterListIcon sx={{ fontSize: "30px", color: "inherit" }} />
            </IconButton>

            {/* Filter Popover */}
            <Popover
              open={open}
              anchorEl={anchorEl}
              onClose={handleClose}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              sx={{
                "& .MuiPopover-paper": {
                  borderRadius: "12px",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                  width: "320px",
                  maxHeight: "450px",
                },
              }}
            >
              <Box sx={{ p: 3 }}>
                {/* Select Center */}
                <Box sx={{ mb: 2 }}>
                  <Typography
                    variant="subtitle2"
                    fontWeight={600}
                    sx={{ mb: 1.5, color: "#333", fontSize: "14px" }}
                  >
                    Select Center
                  </Typography>

                  {/* Search Input */}
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search centers..."
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon
                            sx={{ color: "#999", fontSize: "20px" }}
                          />
                        </InputAdornment>
                      ),
                    }}
                    sx={{
                      mb: 2,
                      backgroundColor: "#f8f8f8",
                      "& .MuiOutlinedInput-root": {
                        borderRadius: "8px",
                        "& fieldset": {
                          borderColor: "#ddd",
                        },
                        "&:hover fieldset": {
                          borderColor: "#009DDF",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: "#009DDF",
                        },
                      },
                      "& .MuiOutlinedInput-input::placeholder": {
                        color: "#999",
                        opacity: 1,
                      },
                    }}
                  />

                  {/* Centers List */}
                  <Box
                    sx={{
                      maxHeight: "280px",
                      overflowY: "auto",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      backgroundColor: "#fafafa",
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#f1f1f1",
                        borderRadius: "10px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#009DDF",
                        borderRadius: "10px",
                      },
                    }}
                  >
                    {filteredCenters?.length > 0 ? (
                      <List sx={{ p: 0 }}>
                        {filteredCenters?.map((center: any, index: number) => (
                          <React.Fragment key={center.center_id}>
                            <ListItem
                              button
                              onClick={() =>
                                handleSelectCenter(center.center_id.toString())
                              }
                              sx={{
                                px: 2,
                                py: 1.5,
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                backgroundColor:
                                  selectedCenter === center.center_id.toString()
                                    ? "#E8F4FD"
                                    : "transparent",
                                "&:hover": {
                                  backgroundColor: "#F4F8FB",
                                },
                                transition: "background-color 0.2s ease",
                              }}
                            >
                              <ListItemIcon
                                sx={{
                                  fontSize: "20px",
                                  color:
                                    selectedCenter ===
                                    center.center_id.toString()
                                      ? "#009DDF"
                                      : "#9e9e9e",
                                }}
                              >
                                <Checkbox
                                  edge="start"
                                  checked={
                                    selectedCenter ===
                                    center.center_id.toString()
                                  }
                                  tabIndex={-1}
                                  disableRipple
                                  sx={{
                                    color: "#ddd",
                                    "&.Mui-checked": {
                                      color: "#009DDF",
                                    },
                                  }}
                                />
                              </ListItemIcon>
                              <ListItemIcon sx={{ minWidth: "36px", ml: 0 }}>
                                <LocationOnIcon
                                  sx={{
                                    fontSize: "20px",
                                    color:
                                      selectedCenter === center.id.toString()
                                        ? "#009DDF"
                                        : "#9e9e9e",
                                  }}
                                />
                              </ListItemIcon>
                              <ListItemText
                                primary={center.center_name}
                                secondary={center.center_id}
                                sx={{
                                  "& .MuiListItemText-primary": {
                                    fontSize: "14px",
                                    fontWeight: 600,
                                    color: "#333",
                                  },
                                  "& .MuiListItemText-secondary": {
                                    fontSize: "12px",
                                    color: "#999",
                                  },
                                }}
                              />
                            </ListItem>
                            {index < filteredCenters.length - 1 && (
                              <Divider sx={{ my: 0 }} />
                            )}
                          </React.Fragment>
                        ))}
                      </List>
                    ) : (
                      <Box
                        sx={{
                          p: 3,
                          textAlign: "center",
                          color: "#999",
                          fontSize: "14px",
                        }}
                      >
                        No centers found
                      </Box>
                    )}
                  </Box>
                </Box>

                {/* Buttons */}
                <Box
                  sx={{
                    display: "flex",
                    gap: 1.5,
                    justifyContent: "center",
                    mt: 3,
                  }}
                >
                  <Button
                    variant="outlined"
                    size="small"
                    onClick={handleCancel}
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      borderColor: "#009DDF",
                      color: "#009DDF",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#f0f8ff",
                        borderColor: "#009DDF",
                      },
                    }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={handleSearch}
                    disabled={!selectedCenter}
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      backgroundColor: "#009DDF",
                      fontWeight: 600,
                      fontSize: "14px",
                      padding: "8px 16px",
                      borderRadius: "8px",
                      "&:hover": {
                        backgroundColor: "#0078b5",
                      },
                      "&:disabled": {
                        backgroundColor: "#ccc",
                        color: "#999",
                      },
                    }}
                  >
                    Search
                  </Button>
                </Box>
              </Box>
            </Popover>
          </Grid>
        </Box>

        {/* Loader */}
        {isLoading && (
          <Typography variant="body1" sx={{ textAlign: "center", my: 4 }}>
            Loading dashboard data...
          </Typography>
        )}

        {!isLoading && SummaryData && (
          <Grid container spacing={3}>
            {/* LEFT SECTION - Summary + Upcoming Classes */}
            <Grid item xs={12} md={4}>
              {/* Summary Cards Row */}
              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12}>
                  <StatusCard
                    title="Total No. of Tutors"
                    value={SummaryData.total_tutors}
                    backgroundColor="#EAF4FB"
                    color="#007BFF"
                  />
                </Grid>
                <Grid item xs={12}>
                  <StatusCard
                    title="Total Classes Assigned"
                    value={SummaryData.total_classes_assigned_this_month}
                    backgroundColor="#E6F4EA"
                    color="#28A745"
                  />
                </Grid>
                <Grid item xs={12}>
                  <StatusCard
                    title="Total Booklet Requests"
                    value={SummaryData.total_booklet_requests_overall}
                    backgroundColor="#F3EAF9"
                    color="#BC57FF"
                  />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <DashboardDonutCard
                    title="Most Requested Subjects"
                    data={subjectData}
                    total={subjectData.reduce(
                      (accumulator: number, item: any) =>
                        accumulator + item.value,
                      0
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <DashboardDonutCard
                    title="Printing Status"
                    data={printingData}
                    total={printingData.reduce((a, b) => a + b.value, 0)}
                  />
                </Grid>
              </Grid>
              {/* Upcoming Classes */}
            </Grid>

            {/* RIGHT SECTION - Pending Requests + Charts */}
            <Grid item xs={12} md={8}>
              {/* Pending Requests */}
              <Box
                sx={{
                  backgroundColor: "#fff",
                  p: 2,
                  borderRadius: 2,
                  boxShadow: 1,
                  mb: 2,
                  height: "345px", // fixed height for the whole card
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                <Typography variant="subtitle1" fontWeight={600} mb={1}>
                  Pending Booklet Requests
                </Typography>

                {/* Scrollable section for table */}
                <Box
                  sx={{
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden", // change to 'auto' if you need horizontal scroll
                  }}
                >
                  <CommonTable2
                    columns={pendingColumns}
                    rows={(formattedPendingRequests || []).map((row: any) => ({
                      ...row,
                      action: (
                        <IconButton
                          sx={{
                            backgroundColor: "#75bef8",
                            color: "#ffffff",
                            borderRadius: "8px",
                            "&:hover": {
                              backgroundColor: "#4a90e2",
                              color: "#ffffff",
                            },
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            console.log(row.request_id, "row that");
                            navigate("/booklet_request/details", {
                              state: { id: row.request_id, isEdit: true },
                            });
                          }}
                        >
                          <EditIcon />
                        </IconButton>
                      ),
                    }))}
                  />
                </Box>
              </Box>
              <Box
                sx={{
                  bgcolor: "white",
                  borderRadius: 2,
                  p: 2,
                  boxShadow: 1,
                  height: "485px", // total box height
                  display: "flex",
                  flexDirection: "column",
                }}
              >
                {/* Table container scrolls inside */}
                <Box
                  sx={{
                    borderRadius: 1,
                  }}
                >
                  <CalendarView
                    events={calendarEvents}
                    onDayClick={handleDayClick}
                    onMonthChange={(month, year) => {
                      console.log("Current month from child:", month, year);
                      setSelectedMonth(month);
                      setSelectedYear(year);
                      // call API or set state
                    }}
                  />
                </Box>
              </Box>
            </Grid>
            <Box
              sx={{
                backgroundColor: "#fff",
                p: 2,
                borderRadius: 2,
                boxShadow: 1,
                marginLeft: "24px",
                marginTop: "24px",
                height: "570px", // fixed box height
                display: "flex",
                width: "100%",
                flexDirection: "column",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  mb: 1,
                }}
              >
                <Typography
                  variant="h6"
                  fontWeight="600"
                  sx={{ color: "#017CC9", fontSize: "14px", flexShrink: 0 }}
                >
                  Scheduled Upcoming Classes
                </Typography>

                <IconButton 
                  onClick={(e) => {
                    setFilterAnchorEl(e.currentTarget);
                    setTempFilters({ ...filters });
                  }}
                >
                  <FilterListIcon sx={{ fontSize: 26, color: "#017CC9" }} />
                </IconButton>
              </Box>

              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: "repeat(5, 1fr)", // Better for 5 items
                  gap: 2,
                  mb: 2,
                  alignItems: "center",
                }}
              >
                {legendItems.map((item, index) => (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    <Box
                      sx={{
                        width: 50,
                        height: 24,
                        bgcolor: item.color,
                        borderRadius: "4px",
                      }}
                    />
                    <Typography sx={{ fontSize: 14 }}>{item.label}</Typography>
                  </Box>
                ))}
              </Box>

              {/* Scrollable table container */}
              <Box
                sx={{
                  flex: 1, // take remaining height
                  overflowY: "auto", // scroll only vertically
                  overflowX: "hidden", // optional
                }}
              >
                <CommonTable2
                  columns={scheduledColumns}
                  rows={filteredUpcomingClasses || []}
                  statusOpen={(row) =>
                    row.print_request !== "not_yet_requested"
                  }
                  onRowClick={(row) => {
                    if (row.print_request !== "not_yet_requested") {
                      navigate("/booklet_request", {
                        state: {
                          request_id: row.request_ids,
                        },
                      });
                    }
                  }}
                />
              </Box>
            </Box>
          </Grid>
        )}

        <Menu
          anchorEl={filteranchorEl}
          open={dropdownOpen}
          onClose={() => setFilterAnchorEl(null)}
          PaperProps={{
            sx: {
              width: 500,
              maxHeight: 600,
              p: 3,
              borderRadius: 3,
              boxShadow: 3,
              overflow: "visible",
            },
          }}
          transformOrigin={{ horizontal: "right", vertical: "top" }}
          anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        >
          <Paper elevation={0} sx={{ borderRadius: 2, mb: 2 }}>
            <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
              Advanced Filters
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary", mb: 2 }}>
              Select options below to filter upcoming classes. Active filters
              will be highlighted.
            </Typography>

            {/* Active Filters Chips */}
            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mb: 2 }}>
              {Object.entries(filters).map(([key, value]: [string, any]) => {
                if (!value || !Array.isArray(value) || value.length === 0) return null;
                return value.map((item: string) => {
                  const options = getOptions(key);
                  const label = options.find((opt: any) => opt.value === item)?.label || item;
                  return (
                    <Chip
                      key={`${key}-${item}`}
                      label={`${columnFilters[key]?.label}: ${label}`}
                      onDelete={() => {
                        const newValue = value.filter((v: string) => v !== item);
                        const newFilters = { ...filters };
                        if (newValue.length === 0) {
                          delete newFilters[key];
                        } else {
                          newFilters[key] = newValue;
                        }
                        setFilters(newFilters);
                        setTempFilters(newFilters);
                      }}
                      variant="outlined"
                      color="primary"
                      size="small"
                    />
                  );
                });
              })}
            </Box>

            <Divider sx={{ mb: 2 }} />
          </Paper>

          <Grid container spacing={2}>
            {scheduledColumns.map((col) => {
              const filterConfig = columnFilters[col.field];
              if (!filterConfig) return null;

              const options =
                typeof filterConfig.options === "function"
                  ? filterConfig.options()
                  : filterConfig.options;

              return (
                <Grid item xs={12} sm={6} key={col.field}>
                  <Typography
                    fontSize={13}
                    fontWeight={600}
                    sx={{ mb: 0.5, color: "#19191aff" }}
                  >
                    {filterConfig.label}
                  </Typography>
                  {filterConfig.type === "select" ? (
                    <FormControl fullWidth size="small" sx={{ mb: 1 }}>
                      <Select
                        multiple
                        value={tempFilters[col.field] || []}
                        onChange={(e) => {
                          let newValue = e.target.value as string[];
                          const allValue = "";
                          if (newValue.includes(allValue)) {
                            newValue = [];
                          }
                          setTempFilters((prev: any) => ({
                            ...prev,
                            [col.field]: newValue,
                          }));
                        }}
                        displayEmpty
                        renderValue={(selected) => {
                          if ((selected as string[]).length === 0) return "All";
                          return (selected as string[])
                            .map(
                              (v) =>
                                options.find((opt: any) => opt.value === v)
                                  ?.label || v
                            )
                            .join(", ");
                        }}
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#e1e3e4ff",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#009ddf",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#009ddf",
                            borderWidth: 2,
                          },
                        }}
                      >
                        {options.map((opt: any) => (
                          <MuiMenuItem key={opt.value} value={opt.value}>
                            {opt.label}
                          </MuiMenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  ) : null}
                </Grid>
              );
            })}
          </Grid>

          {/* Action Buttons */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 2,
              mt: 3,
              pt: 2,
              borderTop: 1,
              borderColor: "divider",
            }}
          >
            <Button
              variant="outlined"
              color="error"
              size="small"
              onClick={() => {
                const cleared = {};
                setFilters(cleared);
                setTempFilters(cleared);
                setFilterAnchorEl(null);
              }}
              sx={{ minWidth: 80, fontSize: "12px", textTransform: "none" }}
            >
              Clear All
            </Button>
            <Button
              variant="contained"
              sx={{
                bgcolor: "#009ddf",
                color: "white",
                fontSize: "12px",
                textTransform: "none",
                minWidth: 80,
                "&:hover": { bgcolor: "#009ddf" },
              }}
              size="small"
              onClick={() => {
                const cleaned = { ...tempFilters };
                Object.keys(cleaned).forEach((k) => {
                  if (Array.isArray(cleaned[k]) && cleaned[k].length === 0) {
                    delete cleaned[k];
                  }
                });
                setFilters(cleaned);
                setFilterAnchorEl(null);
              }}
            >
              Apply Filters
            </Button>
          </Box>
        </Menu>

        <Dialog
          open={openPopup}
          onClose={() => setOpenPopup(false)}
          fullWidth
          maxWidth="md"
        >
          <DialogTitle sx={{ fontWeight: "600", position: "relative", pr: 6 }}>
            Scheduled Classes
            {/* Close Icon */}
            <IconButton
              aria-label="close"
              onClick={() => setOpenPopup(false)}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>

          <DialogContent>
            {/* Legend */}
            <Box sx={{ display: "flex", gap: 3, mb: 2, flexWrap: "wrap" }}>
              {legendItems.map((item, i) => (
                <Box
                  key={i}
                  sx={{ display: "flex", alignItems: "center", gap: 1 }}
                >
                  <Box
                    sx={{
                      width: 30,
                      height: 18,
                      bgcolor: item.color,
                      borderRadius: "4px",
                    }}
                  />
                  <Typography sx={{ fontSize: 14 }}>{item.label}</Typography>
                </Box>
              ))}
            </Box>

            <CommonTable2
              columns={dialogcolumns}
              rows={formattedClasses}
              loading={dateLoading}
              statusOpen={(row) => row.print_request !== "not_yet_requested"}
              onRowClick={(row) => {
                if (row.print_request !== "not_yet_requested") {
                  navigate("/booklet_request", {
                    state: {
                      request_id: row.request_ids,
                    },
                  });
                }
              }}
            />
          </DialogContent>
        </Dialog>

        <AlertBox
          open={openAlert}
          message="⏳No print request from the tutor for a class scheduled within 24 hours"
          onClose={() => {
            sessionStorage.setItem("printerAlertClosed", "true");
            setOpenAlert(false);
          }}
          variant="info"
        />
      </Box>
    </LocalizationProvider>
  );
};

export default AdminDashboard;